module.exports = __webpack_public_path__ + "10_mole.ad7e1a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer2/10_mole.png
// module id = /Wby
// module chunks = 0